// Centralized role-based feature gating.
// Roles:
// - user / verified: limited features
// - full: paid full access
// - admin / super_admin: always full access

const norm = (v) => String(v || '').trim().toLowerCase();

export function normalizeRole(rawRole, isSuperAdmin) {
    if (isSuperAdmin === true) return 'super_admin';
    const r = norm(rawRole);
    // legacy aliases
    if (r === 'проверенный' || r === 'провереный') return 'verified';
    if (r === 'полный') return 'full';
    if (r === 'админ') return 'admin';
    if (r === 'супер админ' || r === 'суперадмин' || r === 'superadmin' || r === 'super-admin') return 'super_admin';
    return r || 'user';
}

export function hasFullAccess(userOrProfile) {
    const role = normalizeRole(userOrProfile?.role, userOrProfile?.is_super_admin);
    if (role === 'full' || role === 'admin' || role === 'super_admin') return true;

    // Time-limited entitlement-based access (backend sends these fields via /api/auth/me and /api/auth/login)
    if (userOrProfile?.has_full_access === true) return true;

    const endsAtRaw = userOrProfile?.full_ends_at;
    if (!endsAtRaw) return false;
    const t = new Date(endsAtRaw).getTime();
    if (!Number.isFinite(t)) return false;
    return t > Date.now();
}

// Standard access:
// - granted by time-limited entitlement(type=standard)
// - implied by full access (VIP/full/admin/super_admin)
// Backend exposes `has_standard_access` and `standard_ends_at` on public profile responses.
export function hasStandardAccess(userOrProfile) {
    if (!userOrProfile) return false;

    // Full implies standard.
    if (hasFullAccess(userOrProfile)) return true;

    // Prefer explicit backend flag when present.
    if (userOrProfile?.has_standard_access === true) return true;

    const endsAtRaw = userOrProfile?.standard_ends_at;
    if (!endsAtRaw) return false;
    const t = new Date(endsAtRaw).getTime();
    if (!Number.isFinite(t)) return false;
    return t > Date.now();
}

export function getGalleryLimit(userOrProfile) {
    return hasFullAccess(userOrProfile) ? 8 : 4;
}

export function canUploadCoverVideo(userOrProfile) {
    return hasFullAccess(userOrProfile);
}

export function canShowWebsite(userOrProfile) {
    return hasFullAccess(userOrProfile);
}

export function upgradeCta() {
    return {
        title: 'Функция недоступна',
        body: 'Чтобы использовать эту функцию, нужно подключить пакет «Полный доступ».',
        primaryText: 'Перейти в аккаунт',
        secondaryText: 'Закрыть',
        href: '/account'
    };
}
